import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n";

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "hi";
    return localStorage.getItem("astrodev_lang") || "hi";
  });

  useEffect(() => {
    localStorage.setItem("astrodev_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];
  const toggle = () => setLang((l) => (l === "hi" ? "en" : "hi"));

  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
